import { Outlet, createFileRoute, useRouterState } from '@tanstack/react-router'
import { Toaster } from '@/components/ui/sonner'
import { MolyLogoFull } from '@/components/app/MolyLogoFull'

export const Route = createFileRoute('/_AuthLayout')({
  component: AuthLayout,
})

/**
 * Routes that render their own full-bleed layout (AuthSplitLayout). Every
 * other child (callback, logout, invite acceptance) still gets the simple
 * centred container with the logo top-left.
 */
const SELF_LAID_OUT_PATHS = ['/auth', '/onboarding']

export default function AuthLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const isSelfLaidOut = SELF_LAID_OUT_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  )

  return (
    <>
      <div className="h-svh overflow-y-auto overflow-x-hidden bg-background">
        {isSelfLaidOut ? (
          <Outlet />
        ) : (
          <div className="flex min-h-full flex-col px-4 py-6 sm:px-10 lg:px-12 lg:py-8">
            <div className="shrink-0">
              <MolyLogoFull className="h-9" />
            </div>
            <div className="flex flex-1 items-center justify-center py-10">
              <div className="w-full max-w-md">
                <Outlet />
              </div>
            </div>
          </div>
        )}
      </div>
      <Toaster richColors position="bottom-center" />
    </>
  )
}
